import { situationsOne } from "./situationsT1";
import { situationsTwo } from "./situationsT2";
import { situationsThree } from "./situationsT3";
import { situationsFour } from "./situationsT4";
import { situationsFive } from "./situationsT5";
import { situationsSix } from "./situationsT6";
import { situationsSeven } from "./situationsT7";
import { situationsEight } from "./situationsT8";
import { situationsNine } from "./situationsT9";
import { situationsTen } from "./situationsT10";

export const situations = {
  one: situationsOne,
  two: situationsTwo,
  three: situationsThree,
  four: situationsFour,
  five: situationsFive,
  six: situationsSix,
  seven: situationsSeven,
  eight: situationsEight,
  nine: situationsNine,
  ten: situationsTen,
};
